<template>
	<div>
		<section class="container-fluid mt-2">
			<div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                        <div class="mr-auto">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb clearfix pt-3">
                                    <li class="breadcrumb-item active">Personal</li>
                                </ol>
                            </nav>
                        </div>
                    </nav>
                </div>
            </div>
			<div class="row">
				<div class="col-md-12 col-lg-12 col-xl-12 mt-2">
					<Clist :isCrm="true" :pShowBtnAdd="ShowBtns" :ShowHead="false" @FiltrarC="Lista" :Filtro="Filtro" :regresar="true"  :Nombre="NameList"  :isModal="EsModal" :pConfigLoad="ConfigLoad" :isContactos="true">
						<template slot="Filtros">

                        </template>
						<template slot="cards">
							<div class="row row-cols-md-4 row-cols-lg-4 row-cols-xl-2 mt-3">
								<div v-for="(lista,key,index) in ListaTrabajador" :key="index" class="col-sm-4 col-md-4 custom-col-7 card-group">
									<div @click="IrATarjeta(lista.IdTrabajador)" class="card mb-3 tarjetacliente" style="border:2px solid #0F3F87;cursor:pointer;">
										<img height="190px" v-if="lista.Foto2!=null && lista.Foto2!=''" class="card-img-top" :src="RutaImagenTrabajador+lista.Foto2" alt=""/>
										<div v-else class="card-img-top" style="background-color:#b4b4b4;padding:75px;height:190px"></div>
										<div class="card-body pt-2">
											<div class="row mt-1">
												<div class="col-lg-12">
													<h6 class="m-0">
                                        	            {{lista.Nombre.toUpperCase() }}
                                        	        </h6>
													<b>Profesión: </b> {{ lista.Profesion }}
													<br>
													<b>Teléfono: </b>{{ lista.Telefono }}
													<br>
													<b>Ingreso:</b> <i class="fa fa-calendar"></i>  {{ lista.FechaIngreso!=null && lista.FechaIngreso!='' && lista.FechaIngreso!='0000-00-00' ? $getCleanDate(lista.FechaIngreso,false) : '-' }}
													<br>
													<b>Perfil: </b>{{lista.Perfil == 'Usuario APP' ? 'Usuario App Web' : lista.Perfil}}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</Clist>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Clist from '@/components/Clist.vue';
export default {
	name :'list',
    props:[],
    components :{
        Clist
        // Menu,
    },
	data() {
		return {
			NombreSeccion: 'Personal',
            FormName:'PersonalForm',
            EsModal:true,
            size :"modal-lg",
            NameList:"Personal",
            EmitSeccion:"Personal",
            // EmitSeccionTrabajador:"AgregarTrabajador",
            urlApi:"trabajador/get",
            ListaTrabajador:[],
            ShowBtns:true,
            TipoList:'',
            Filtro:{
                Nombre:'',
                Placeholder:'Nombre..',
                TotalItem:0,
                Pagina:1,
                Entrada:30,
				RegEstatus:'A'
            },
            oBtnSave:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Personal",
                EmitSeccion:'Personal'
            },
            // oBtnSaveTrabajador:{
            //     isModal:true,
            //     disableBtn:false,
            //     toast:0,
            //     nombreModal:"AgregarTrabajador",
            //     EmitSeccion:'AgregarTrabajador'
            // },
            ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
            RutaImagenTrabajador:"",
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader = true;
			await this.$http.get(
                this.urlApi,
                {
                    params:{
                        Nombre: this.Filtro.Nombre,
						Entrada: this.Filtro.Entrada,
						pag: this.Filtro.Pagina,
						RegEstatus: this.Filtro.RegEstatus,
						Origen:"Admin"
                    }
                }
            ).then((res)=>{
                this.ListaTrabajador = res.data.data.trabajador;
				this.RutaImagenTrabajador=res.data.data.rutatrabajador;
				this.Filtro.Entrada = res.data.data.pagination.PageSize;
				this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
            }).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});
		},
		IrATarjeta(IdTrabajador){
			this.$router.push({name:'checkindetalle',params:{Id:IdTrabajador,pOrigen:'Tarjeta'}});
		}
	},
	created() {
		this.bus.$off('List');
		this.bus.$on('List',()=> 
        {
            this.Lista();
        });
	},
	mounted() {
		this.Lista();
	},
}
</script>

<style scoped>
	.custom-col-7{
		flex: 0 0 calc(100% / 7);
  		max-width: calc(100% / 7);
	}
	@media (max-width: 576px) {
    	.custom-col-7 {
    		flex: 0 0 100%;
    		max-width: 100%; /* 1 por fila en xs */
  		}
	}
	@media (max-width: 1200px) {
	  .custom-col-7 {
	    flex: 0 0 calc(100% / 4);
	    max-width: calc(100% / 4); /* 4 por fila en pantallas grandes */
	  }
	}

	@media (max-width: 992px) {
	  .custom-col-7 {
	    flex: 0 0 calc(100% / 3);
	    max-width: calc(100% / 3); /* 3 por fila en md */
	  }
	}

	@media (max-width: 768px) {
	  .custom-col-7 {
	    flex: 0 0 50%;
	    max-width: 50%; /* 2 por fila en sm */
	  }
	}

</style>
